import React from 'react';
import PropTypes from 'prop-types';
import { Field } from '@availity/form';
import { FormGroup, Label } from 'reactstrap';

const AmountCheckbox = props => {
  const { fieldId, fieldName, changeFunc, fieldVal, blurFunc } = props;

  return (
    <FormGroup for={fieldId} className='label-font'>
      <Label htmlFor={fieldId}>
        Amount*
      </Label>  
      <div>
        <span className='dollar-sign'>&#36;</span>
        <Field
          type='text'
          id={fieldId}
          name={fieldName}
          className='straighten-borders incomeSourceAmt right-text'
          onChange={changeFunc}
          onBlur={blurFunc}
          value={fieldVal}
          maxLength={6}
        />
      </div>
    </FormGroup>
  )
}


AmountCheckbox.propTypes = {
  fieldId: PropTypes.string,
  fieldName: PropTypes.string,
  changeFunc: PropTypes.func,
  blurFunc: PropTypes.func,
  fieldVal: PropTypes.string
}

export default AmountCheckbox;